import { render, staticRenderFns } from "./reportProficientList.vue?vue&type=template&id=82ba15d6&scoped=true"
import script from "./reportProficientList.vue?vue&type=script&lang=js"
export * from "./reportProficientList.vue?vue&type=script&lang=js"
import style0 from "./reportProficientList.vue?vue&type=style&index=0&id=82ba15d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ba15d6",
  null
  
)

export default component.exports